import TabBar from '@mobile/components/TabBar.vue';

export default {
    functional: true,
    render(h, { parent }) {
        return h(TabBar, {
            class: '',
            props: {
                tabs: [
                    {
                        title: parent.$t('Templates'),
                        route: { name: 'checklists' },
                    },
                    {
                        title: parent.$t('Started'),
                        route: { name: 'drafts' },
                    },
                    {
                        title: parent.$t('Done'),
                        route: { name: 'done-inspections' },
                    },
                ],
            },
        });
    },
};
